import React from "react";
import LoginComponent from "../components/regis login/login/fom login/FormLogin"

function LoginPage(){
    return (
        <React.Fragment>
            <LoginComponent/>
        </React.Fragment>
    )
}

export default LoginPage;